<!--
  TeleworkLinkInputDialog.vue
    Telework Link Input Function Dialog Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog v-model="mVisible" persistent max-width="400px">
    <div class="hm-td">
      <div class="hm-bg-primary hm-td-title">勤怠入力</div>

      <v-divider />

      <!-- 勤務時間入力 -->
      <v-layout row wrap class="hm-td-datetime">
        <v-flex xs2>
          <v-btn flat icon class="hm-td-datetime-icon" @click="getDateTime">
            <v-icon large color="green darken-4">access_time</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs5>
          <v-menu
            ref="mDpicker"
            v-model="mDpicker"
            :close-on-content-click="false"
            :return-value.sync="mSelDate"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
           >
            <v-text-field
              class="hm-ewd-text-date mr-3"
              slot="activator"
              v-model="mSelDate"
              readonly
              background-color="grey lighten-2"
            ></v-text-field>
            <v-date-picker
             v-model="mSelDate"
             scrollable
            >
              <v-btn flat color="primary" @click="mDpicker = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.mDpicker.save(mSelDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs5>
          <v-menu
            ref="mTpicker_ref"
            v-model="mTpicker"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="mSelTime"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              class="hm-ewd-text-time mr-3"
              slot="activator"
              v-model="mSelTime"
              readonly
              background-color="grey lighten-2"
            ></v-text-field>
            <v-time-picker
              v-if="mTpicker"
              v-model="mSelTime"
              full-width
              format="24hr"
              actions
            > <!--v-ifによって、再度時間設定画面を表示したときに時間から入力できるようになる-->
              <v-btn flat color="primary" @click="mTpicker = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.mTpicker_ref.save(mSelTime)">OK</v-btn>
            </v-time-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs2><!--位置調整--></v-flex>
        <v-flex xs10>
          <div class="hm-td-latest-data-text">前回：{{mLatestDateTimeText}} {{mLatestCategoryName}}</div>
        </v-flex>
      </v-layout>

      <v-divider />

      <!-- 位置情報 -->
      <v-layout wrap align-center class="hm-td-location">
        <v-flex xs2 class="hm-td-location-icon">
          <v-icon large color="pink lighten-1">location_on</v-icon>
        </v-flex>
        <v-flex xs10>
          <div :class="{'hm-hide': !mMapDisp}">
            <map-area
              :pmapid="mMapName"
              ref="mapobjTwLink"
              class="hm-td-map-area"
            >
            </map-area>
          </div>
          <div :class="{'hm-hide': mMapDisp}" class="hm-td-location-disp">( 位置情報なし )</div>
        </v-flex>
      </v-layout>

      <v-divider />

      <!-- コメント -->
      <v-layout row wrap class="hm-td-memo">
        <v-flex xs2><v-icon large color="blue hm-td-icon">message</v-icon></v-flex>
        <v-flex xs8>
          <v-form v-model="mTdFormValid">
            <v-textarea
              v-model="mComment"
              :rules="[mTdMsgRules.counter]"
              label="Comment"
              rows=2
              box
              caption
            >
            </v-textarea>
          </v-form>
        </v-flex>
        <v-flex xs1>
          <v-btn small icon flat color="primary" @click="onClickMessageClear">
            <v-icon>backspace</v-icon>
          </v-btn>
        </v-flex>
       </v-layout>

      <v-divider />

      <!-- ボタン -->
      <div class="hm-td-btn-outer">
        <v-btn
          color="primary"
          class="white--text hm-td-btn"
          :disabled="(!mTdFormValid) || (mIsUpdating)"
          @click="onClickOk"
        >
          {{mDispCategory}}
        </v-btn>
        <v-btn
          color="secondary"
          class="white--text hm-td-btn"
          @click="onClickClose"
        >
          送信しない
        </v-btn>
      </div>

    </div>

    <!-- ダイアログ設定 -->
    <errorinfo-dialog ref="errorInfoDialog">
      <div slot="msg">{{ mErrMsg }}</div>
    </errorinfo-dialog>
    <errorinfo-dialog-fail ref="errorInfoDialogFail">
      <div slot="msg">登録に失敗しました。しばらくしてから再度実行して下さい。</div>
    </errorinfo-dialog-fail>
    <systeminfo-dialog ref="systemInfoDialog">
      <div slot="msg">{{ mSysMsg }}</div>
    </systeminfo-dialog>
  </v-dialog>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import {
  TeleworkCategory,
  TeleworkCategoryNames,
  getNowDatetimeMoment,
  formatDateMoment,
  isNullorUndefined,
  getGeoLocation,
} from '@/common'
import ErrorInfoDialog from '@/components/dialogs/ErrorInfoDialog'
import SystemInfoDialog from '@/components/dialogs/SystemInfoDialog'
import MapOSMOL from '@/components/MapOSMOL'

export default {
  name: 'Telework',
  data: () => ({
    mVisible: false,
    mTeleworkCategory: TeleworkCategory,
    mTeleworkCategoryNames: TeleworkCategoryNames,
    mCategoryId: 0,
    mDispCategory: '',
    mLinkedDate: '',
    mLatestDatetime: '',
    mLatestDateTimeText: '',
    mLatestCategoryName: '',
    mSelDate: '',
    mSelTime: '',
    mGeoLocationMsg: 'nothing',
    mComment: '',
    mIsUpdating: false,
    mTdFormValid: true,
    mTdMsgRules: {
      counter: v => ((v == null) || (v.length <= 100)) || '100文字以内で入力してください',
    },
    mGeolocation: {
      lat: '',
      lon: ''
    },
    mMapName: 'hm-map-tw-link',
    mMapDisp: true,
    mMapZoom: 15,
    mErrMsg: '',
    mSysMsg: '',
    mWarningMsg: '',
    mDpicker: false,
    mTpicker: false,
    mUserInfo: {
      companyId: '',
      userId: '',
      staffId: ''
    },
  }),
  components: {
    'errorinfo-dialog': ErrorInfoDialog,
    'errorinfo-dialog-fail': ErrorInfoDialog,
    'systeminfo-dialog': SystemInfoDialog,
    'map-area': MapOSMOL,
  },
  mounted: function () {
    this.$log.debug('# Telework')
    // Teleworkボタンがクリックされた時のハンドラを登録
    this.$on('onClickTelework', this.onClickTelework)
  },
  destroyed: function () {
    this.$log.debug('# Telework')
  },
  computed: {
  },
  methods: {
    // -------------------------------------------------------------------------
    // A Handler on User Settings Menu
    //onClickTelework: async function (company_id, user_id, staff_id, category) {
    onClickTelework: async function (category) {
      this.mUserInfo.companyId = this.$store.getters.loginUserCompanyId
      this.mUserInfo.userId = this.$store.getters.loginUserId
      this.mUserInfo.staffId = this.$store.getters.loginUserBaseInfo.staff_id
      this.mTdFormValid = true
      this.mCategoryId = category

      this.getDateTime()
      if (await this.getLatestStatus() === false) {
        return
      }

      this.mDispCategory = this.mTeleworkCategoryNames[Number(this.mCategoryId) - 1]

      let elm = document.getElementById('hm-map-tw-link')
      if (this.mVisible === true || elm.innerHTML !== '') {
        // 勤怠入力ダイアログ表示済みの場合、重複表示を回避
        return
      }

      this.mVisible = true  // Show Dialog
      const locate = await getGeoLocation(this.$store.getters.isMobile, this.$store.getters.isGnssReady)
      if (locate.result === 'ng') {
        this.mMapDisp = false
        this.mErrMsg = locate.alertMsg
        this.$refs.errorInfoDialog.$emit('show')
      }
      else {
        locate.lon = Number(locate.lon)
        locate.lat = Number(locate.lat)

        // 地図をクリアしてから再描画する
        this.$refs.mapobjTwLink.renderMap()
        this.$refs.mapobjTwLink.setMarker(this.mMapZoom, locate.lon, locate.lat)
      }
      this.mGeolocation.lat = locate.lat
      this.mGeolocation.lon = locate.lon
      this.mComment = ''
    },
    // -------------------------------------------------------------------------
    // On Click Ok
    onClickOk: async function () {
      if (!this.mTdFormValid || this.mIsUpdating) {
        // 入力エラー
        return
      }
      let send_data = this.getSendData(this.mCategoryId)

      // データチェック
      const send_datetime = send_data.teleworkLog.date.replace(/-/g, '') + send_data.teleworkLog.time.replace(/:/g, '')
      if (send_datetime <= this.mLatestDatetime) {
        // 直近入力データより過去の日時である場合はエラー
        this.mErrMsg = '直前の勤務時間よりも前の時間は登録できません。'
        this.$refs.errorInfoDialog.$emit('show')
        return
      }

      this.mIsUpdating = true   // ボタン連打による重複送信を防止

      // 勤怠情報送信
      const tw_result = await this.$store.dispatch('aSendTeleworkLog', send_data)
      if (tw_result.body.mismatch) {
        // 送信すれ違いにより、登録時に状態不整合を検出した場合
        this.mSysMsg = '別の勤怠情報がすでに登録されているため、登録できませんでした。'
        this.$refs.systemInfoDialog.$emit('show')
        this.mIsUpdating = false
        return
      }
      if (!tw_result.error && !tw_result.body.error) {
        // ログインユーザの直近勤務種別を更新
        this.$store.dispatch('aSetLatestTeleworkCategory', this.mCategoryId)

        // テレワーク勤務中社員リスト操作
        /*if (this.mCategoryId === TeleworkCategory.END) {
          this.$store.dispatch('aDelTeleworkingUserList', send_data.teleworkLog.staff_id.toString())
        }
        else {
          this.$store.dispatch('aAddTeleworkingUserList', send_data.teleworkLog.staff_id.toString())
        }*/

        // 行先情報送信
        this.$emit('onUpdateWhereabouts')
        this.onClickClose()
      }
      else {
        this.$refs.errorInfoDialogFail.$emit('show')
      }
      this.mIsUpdating = false
    },
    // -------------------------------------------------------------------------
    // On Click Close
    onClickClose: function () {
      this.mTdFormValid = true
      this.mVisible = false
      this.mMapDisp = true
      let elm = document.getElementById('hm-map-tw-link')
      if (elm !== null) {
        elm.innerHTML = ''
        this.$refs.mapobjTwLink.clearMarker()
      }
    },
    // -------------------------------------------------------------------------
    // On Click Message Clear
    onClickMessageClear: function () {
      this.mComment = ''
    },
    // -------------------------------------------------------------------------
    // Get now date time
    getDateTime: function () {
      this.mSelDate = formatDateMoment(getNowDatetimeMoment(), 'YYYY-MM-DD')
      this.mSelTime = formatDateMoment(getNowDatetimeMoment(), 'HH:mm')
      /*let nowMin = ('0' + (Math.floor(Number(nowTime.slice(3)) / 5) * 5).toString()).slice(-2)
      this.mSelTime = nowTime.slice(0, 3) + nowMin
      this.mNowDate = this.mSelDate*/
    },
    // -------------------------------------------------------------------------
    getLatestStatus: async function () {
      if (isNullorUndefined(this.mUserInfo.staffId) ||
          isNullorUndefined(this.mUserInfo.companyId)) {
        this.$log.error('staff id or company id is null or undefined.')
        // @Todo エラーダイアログ表示
        return false
      }

      // 表示をクリア
      this.mLatestDatetime = ''

      // サーバから直近の勤務状態を取得
      const result = await this.$store.dispatch('aGetLatestTeleworkStatus', this.mUserInfo)
      if (!result.error && !result.body.error) {
        // 表示を更新
        //this.$log.debug('★[getLatestStatus]直近データ取得(' + JSON.stringify(result.body.body) + ')')
        if (!isNullorUndefined(result.body.body)) {
          const data = result.body.body
          if (isNullorUndefined(data.staff_id)) {
            if (this.mCategoryId === TeleworkCategory.START) {
              // 直近データが無い場合は、送信する勤務種別が勤務開始の場合のみダイアログを開く
              this.mLatestDateTimeText = '(なし)'
              this.mLatestCategoryName = ''
              this.mLatestDatetime = ''
              this.mLinkedDate = ''
              return true
            }
            else {
              return false
            }
          }
          // 直近の勤務種別と送信する勤務種別の相関関係チェック
          let latestCategoryId = Number(data.category)
          //this.$log.debug('★直近の勤務種別(' + latestCategoryId + ')、送信する勤務種別(' + this.mCategoryId + ')')
          if (latestCategoryId === this.mCategoryId) {
            // 直近の勤務種別と、
            // 現在選択中の在席アイコンに連動する勤務種別が一致
            //this.$log.debug('★  →一致(連動ダイアログを表示しない)')
            return false
          }
          switch (latestCategoryId) {     // 直近に送信した勤務種別
            case TeleworkCategory.START:
              // 「勤務開始」
              break
            case TeleworkCategory.LEAVE:
              // 「離席」
              if (this.mCategoryId === TeleworkCategory.START) {
                // 送信する勤務種別が「勤務開始」の場合
                // 送信する勤務種別を「着席」とする
                this.mCategoryId = TeleworkCategory.SEATED
              }
              break
            case TeleworkCategory.SEATED:
              // 「着席」
              if (this.mCategoryId === TeleworkCategory.START) {
                // 送信する勤務種別が「勤務開始」の場合
                return false
              }
              break
            case TeleworkCategory.END:
              // 「勤務終了」
              if (this.mCategoryId === TeleworkCategory.LEAVE) {
                // 送信する勤務種別が「離席」の場合
                return false
              }
              break
            default:
              break
          }

          // 最後に入力した勤務データを表示
          const date = data.input_date
          const hour = data.input_hour
          this.mLatestDateTimeText = date.slice(0, 4) + '-' + date.slice(4, 6) + '-' + date.slice(6, 8) + ' ' + hour.slice(0, 2) + ':' + hour.slice(2, 4)
          this.mLatestCategoryName = '[ ' + TeleworkCategoryNames[latestCategoryId - 1] + ' ]'
          //this.$log.debug('★  勤務種別(' + this.mLatestCategoryName + ')  日時(' + this.mLatestDateTimeText + ')')

          // 入力チェック用
          this.mLatestDatetime = data.input_date + data.input_hour
          this.mLinkedDate = data.linked_date
        }
      }
      else {
        // エラーは無視
      }
      return true
    },
    // -------------------------------------------------------------------------
    getSendData: function (category) {
      let linked_date = this.mSelDate.replace(/-/g, '')
      if (category !== this.mTeleworkCategory.START) {
        linked_date = this.mLinkedDate
      }
      const telework_log = {
        staff_id: this.mUserInfo.staffId,
        date: this.mSelDate,
        time: this.mSelTime,
        category: category,
        lat: this.mGeolocation.lat,
        lon: this.mGeolocation.lon,
        comment: this.mComment,
        updated: 0,
        linked_date: linked_date
      }
      return {
        userId: this.mUserInfo.userId,
        companyId: this.mUserInfo.companyId,
        teleworkLog: telework_log,
      }
    },
    allowedMinutes: function (v) {
      return ((v % 5) === 0)
    },
    clearTdSendData: function () {
      this.mStartDate = ''
      this.mStartHour = ''
      this.mLeaveDate = ''
      this.mLeaveHour = ''
      this.mSeatedDate = ''
      this.mSeatedHour = ''
      this.mEndDate = ''
      this.mEndHour = ''
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-td {
  text-align: center;
  background-color: whitesmoke;
}
.hm-td-title {
  padding: 20px;
  color: white;
  font-size: 1.2em;
  font-weight: bold;
}
.hm-td-icon {
  margin-top: 10px;
}
.hm-td-category {
  height: 60px;
  line-height: 60px;
  font-size: 1.1em;
  font-weight: bold;
}
.hm-td-category-text {
  text-align: left;
  padding-left: 5px;
}
.hm-td-datetime {
  height: 50px;
  line-height: 50px;
  font-size: 1.5em;
  font-weight: bold;
}
.hm-td-datetime-icon {
  padding-top: 12px;
}
.hm-td-latest-data-text {
  font-size: 0.9em;
  margin-bottom: 10px;
  text-align: left;
}
.hm-td-location {
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 0.9em;
  font-weight: normal;
}
.hm-td-location-icon {
  height: 20vh;   /*アイコン位置を上寄せするために、地図領域の高さと合わせる*/
  padding-top: 10px;
}
.hm-td-location-disp {
  text-align: left;
}
.hm-td-map-area {
  width: 95%;
  height: 20vh;
}
.hm-td-memo {
  margin-top: 10px;
  font-size: 0.5em;
}
.hm-td-btn-outer {
  margin: 0 auto;
}
.hm-td-btn {
  margin: 15px 3px;
}
.hm-dialog-msg-area {
  margin: 0 15px;
  font-size: 0.92em;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/TeleworkLinkInputDialog.vue